import Vue from 'vue'

window.Vue = Vue

if (document.getElementById('subscription')) {

    new Vue({
        el: '#subscription',
        data: {
            error: false,
            isActive: false,
            isSending: false,
            form: undefined,
            date: null,
            storeKey: 'gibbstonSubscription',
            waitTime: 30000,
            verified: true,
            defaultError: 'There was an error, please try again',
            errorMessage: 'There was an error, please try again',
        },
        computed: {
            classList() {
                return this.isActive ? 'active' : ''
            },
            buttonText() {
                return 'Submit'
            },
            buttonMethod() {
                return this.submitForm
            }
        },
        watch: {
            isActive: function() {
                const method = this.isActive ? 'add' : 'remove'
                document.querySelector('body').classList[method]('subscription-active')
            }
        },
        mounted() {
            this.form = this.$el.querySelector('form')
            this.form.addEventListener('submit', this.submitForm)

            // Fix bug with tabbing while on email input
            this.$refs.NewsletterEmail.addEventListener('keydown', e => {
                if(e.keyCode === 9 || e.keyCode === 13) {
                    e.preventDefault()
                    this.next()
                }
            })

            const store = window.localStorage.getItem(this.storeKey)
            this.date = new Date();
            this.date.setDate(this.date.getDate() + 7)

            if(store === null || (new Date().getTime() > parseInt(store))) {
                setTimeout(() => {
                    this.isActive = true
                }, this.waitTime)
            }
        },
        methods: {
            toggle() {
                if(this.isActive) {
                    this.isActive = false;
                    this.setToken()
                } else {
                    this.isActive = true;
                }
            },
            close(e) {
                if (e.target.getAttribute('id') === 'subscription') {
                    this.isActive = false
                    this.setToken()
                }
            },
            setToken() {
                window.localStorage.setItem(this.storeKey, this.date.getTime())
            },
            submitForm(e) {
                e.preventDefault()

                let els = this.form.elements;
                let data = new FormData();
                for (let i = 0 ; i < els.length; i++)
                    if (els[i].type !== "submit")
                        data.append(els[i].name, els[i].value)

                this.isSending = true

                fetch(this.form.action, {
                    method: 'POST',
                    body: data,
                    headers: {
                        "Accept": "application/json; charset=utf-8",
                        "x-requested-with": "XMLHttpRequest"
                    },
                })
                    .then(res => res.json())
                    .then(res => {
                        if(res.success) {
                            this.setToken();
                            this.isActive = false
                            this.error = false
                        } else {
                            if(res.success === false) {
                                console.warn("Something went wrong check the return method.")
                                this.errorMessage = this.defaultError
                                this.isActive = false
                            } else {
                                this.error = true
                                this.errorMessage = res[0].message
                            }
                        }
                        this.isSending = false
                    })
            }
        }
    })
}
